module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "min-width": "10rem",
      "offset-y": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": !_vm.caption,
      "flat": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.caption) + "\n      "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.actions), function(action) {
    return [(action.divider) ? _c('v-divider') : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isVisible()),
        expression: "action.isVisible()"
      }],
      key: action.caption(),
      on: {
        "click": function($event) {
          return action.run()
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(action.caption()))])], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f78eaca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ActionsBtn.vue
// module id = 865
// module chunks = 1